document.addEventListener("DOMContentLoaded", function () {
  $("#pending-reports-carousel").owlCarousel({
    // Configuration for pending reports carousel
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  });

  $("#completed-reports-carousel").owlCarousel({
    // Configuration for completed reports carousel
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  });

  const createItem = (order) => {
    const itemContainer = $("<div>").addClass("item test-card").addClass("report-card");
    const heading = $("<h4>").text(order.name).addClass("report-title");

    const userDiv = $("<div>").addClass("d-flex align-items-center").css({ gap: "1rem" });
    const userName = $("<span>").text(order.customer_name);
    const userIcon = $("<img>").addClass("icon-img").attr({
      width: 20,
      height: 20,
      src: "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/circle-user.svg?v=1700303924",
    });

    userDiv.append(userIcon, userName);

    const dateDiv = $("<div>").addClass("d-flex align-items-center").css({ gap: "1rem" });
    const dateSpan = $("<span>").text(order.created_at);
    const dateIcon = $("<img>").addClass("icon-img").attr({
      width: 20,
      height: 20,
      src: "https://cdn.shopify.com/s/files/1/0734/2968/0445/files/calender.svg?v=1700303908",
    });

    dateDiv.append(dateIcon, dateSpan);

    const nameContainer = $("<div>")
      .addClass("flex flex-row name-container")
      .append(userDiv, dateDiv);

    const wrapper = $("<div>")
      .addClass("d-flex flex-column justify-content-between items-center")
      .append(nameContainer);

    const encodedId = encodeURIComponent(order.id)
    const statusDiv = $("<div>").addClass("mt-2")

    const statusSpan = $("<span>")
      .addClass("")
      .css({ "margin-right": "5px" })

    let statusText = $("<span>")
      .text(order.status)
      .addClass(
        "status-card"
      )



    if (order.status === "completed") {
      const resultPageUrl = `/pages/result/${encodedId}`;
      const viewDetailsButton = $("<button>")
        .addClass("btn-primary-custom view-details")
        .text("View Details")
        .on("click", () => {
          window.location.href = resultPageUrl; // Navigate to the result page
        });
      statusText = $("<span>")
        .text(order.status)
        .addClass(
          "status-card-green"
        )
      statusDiv.append(statusSpan, statusText)
      statusDiv.append(viewDetailsButton);

    }else{
      statusDiv.append(statusSpan, statusText)

    }


    itemContainer.append(heading, wrapper, statusDiv);

    return itemContainer;
  };

  const fetchOrderList = async () => {
    try {
      if (!userId) {
        throw new Error("Customer not logged in");
      }

      const apiUrl = `${backend_url}/shopify/test-results?user_id=${userId}`;

      const response = await fetch(apiUrl, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const { data } = (await response.json()) || [];

      console.log("Order list fetched:", data);

      return data;
    } catch (error) {
      console.error("Error fetching order list:", error);
      return null;
    }
  };

  fetchOrderList()
    .then((orderList) => {
      if (orderList && orderList.length > 0) {
        const pendingOrders = orderList.filter(
          (order) => order.status !== "completed"
        );
        const completedOrders = orderList.filter(
          (order) => order.status === "completed"
        );

        const pendingContainer = $("#pending-reports-carousel .owl-stage ");
        const completedContainer = $("#completed-reports-carousel .owl-stage");

        pendingContainer.empty();
        completedContainer.empty();

        if (pendingOrders.length === 0) {
          pendingContainer.append("<p>No results found!</p>").addClass("no-data-found");
        } else {
          pendingOrders.forEach((order) => {
            const newItem = createItem(order);
            pendingContainer.append(newItem).addClass("report-status");
          });
        }

        if (completedOrders.length === 0) {
          completedContainer.append("<p>No results found!</p>").addClass("no-data-found");
        } else {
          completedOrders.forEach((order) => {
            const newItem = createItem(order);
            completedContainer.append(newItem).css(".report-card");
          });
        }

        // Refresh Owl Carousels to reflect changes
        $("#pending-reports-carousel").trigger("refresh.owl.carousel");
        $("#completed-reports-carousel").trigger("refresh.owl.carousel");

        console.log("Pending Orders:", pendingOrders);
        console.log("Completed Orders:", completedOrders);
      } else {
        console.log("No orders found");
      }

      window.orderList = orderList;
      console.log("Order list received:", orderList);
    })
    .catch((error) => {
      // Handle errors
      console.error("Error:", error);
    });

    const printButton = document.getElementById("printButton");
    if (printButton) {
      printButton.addEventListener("click", function() {
        window.print();  // Trigger the print dialog
      });
    }
});
